var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGlUserFilled(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4909 12.008C13.4909 12.8389 12.8229 13.507 11.9919 13.507H3.9919C3.16094 13.507 2.49292 12.8389 2.49292 12.008C2.49292 9.79209 3.81267 7.90207 5.6864 7.02223C6.30554 7.54362 7.10392 7.86949 7.98375 7.86949C8.86359 7.86949 9.66196 7.54362 10.2811 7.02223C12.1874 7.88578 13.4909 9.79209 13.4909 12.008ZM10.4929 4.4316C10.4929 3.09555 9.36868 2.00391 8.00005 2.00391C6.61512 2.00391 5.50718 3.09555 5.50718 4.4316C5.50718 5.76765 6.63141 6.8593 8.00005 6.8593C9.36868 6.8593 10.4929 5.78395 10.4929 4.4316Z",
    fill: "#141938"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlUserFilled);
export default __webpack_public_path__ + "static/media/gl_user_filled.ad1a6dafa3a1ad0cfa4bbe1bbfc395c5.svg";
export { ForwardRef as ReactComponent };